module.exports = __webpack_public_path__ + "img/32-heat-cramping-fr.42ecd017.svg";